export const ActionNames = {
    ALERT_SUCCESS: 'ALERT_SUCCESS',
    ALERT_WARNING: 'ALERT_WARNING',
    ALERT_ERROR: 'ALERT_ERROR',
    ALERT_CLEAR: 'ALERT_CLEAR',
    MESSAGE_CATEGORY_CHANGE: 'MESSAGE_CATEGORY_CHANGE',
    NOTES_REQ_APPROVAL_LOAD_REQUEST: 'NOTES_REQ_APPROVAL_LOAD_REQUEST',
    NOTES_REQ_APPROVAL_LOAD_SUCCESS: 'NOTES_REQ_APPROVAL_LOAD_SUCCESS',
    NOTES_REQ_APPROVAL_LOAD_FAILURE: 'NOTES_REQ_APPROVAL_LOAD_FAILURE',
    NOTES_REQ_APPROVAL_APPROVE_ALL_REQUEST: 'NOTES_REQ_APPROVAL_APPROVE_ALL_REQUEST',
    NOTES_REQ_APPROVAL_APPROVE_ALL_SUCCESS: 'NOTES_REQ_APPROVAL_APPROVE_ALL_SUCCESS',
    NOTES_REQ_APPROVAL_APPROVE_ALL_FAILURE: 'NOTES_REQ_APPROVAL_APPROVE_ALL_FAILURE',
    NOTES_REQ_APPROVAL_SET_SELECTED_MESSAGE: 'NOTES_REQ_APPROVAL_SET_SELECTED_MESSAGE',
    NOTES_REQ_APPROVAL_MARK_READ_REQUEST: 'NOTES_REQ_APPROVAL_MARK_READ_REQUEST',
    NOTES_REQ_APPROVAL_MARK_READ_SUCCESS: 'NOTES_REQ_APPROVAL_MARK_READ_SUCCESS',
    NOTES_REQ_APPROVAL_MARK_READ_FAILURE: 'NOTES_REQ_APPROVAL_MARK_READ_FAILURE',
    NOTES_REQ_APPROVAL_APPROVE_REQUEST: 'NOTES_REQ_APPROVAL_APPROVE_REQUEST',
    NOTES_REQ_APPROVAL_APPROVE_SUCCESS: 'NOTES_REQ_APPROVAL_APPROVE_SUCCESS',
    NOTES_REQ_APPROVAL_APPROVE_FAILURE: 'NOTES_REQ_APPROVAL_APPROVE_FAILURE',
    NOTES_REQ_APPROVAL_REJECT_REQUEST: 'NOTES_REQ_APPROVAL_REJECT_REQUEST',
    NOTES_REQ_APPROVAL_REJECT_SUCCESS: 'NOTES_REQ_APPROVAL_REJECT_SUCCESS',
    NOTES_REQ_APPROVAL_REJECT_FAILURE: 'NOTES_REQ_APPROVAL_REJECT_FAILURE',
    NOTES_REQ_APPROVAL_TOGGLE_REJECT: 'NOTES_REQ_APPROVAL_TOGGLE_REJECT',
    NOTES_REQ_APPROVAL_PDF_LOAD_REQUEST: 'NOTES_REQ_APPROVAL_PDF_LOAD_REQUEST',
    NOTES_REQ_APPROVAL_PDF_LOAD_SUCCESS: 'NOTES_REQ_APPROVAL_PDF_LOAD_SUCCESS',
    NOTES_REQ_APPROVAL_PDF_LOAD_FAILURE: 'NOTES_REQ_APPROVAL_PDF_LOAD_FAILURE',
    NOTES_REQ_APPROVAL_PDF_OPEN_REQUEST: 'NOTES_REQ_APPROVAL_PDF_OPEN_REQUEST',
    NOTES_REQ_APPROVAL_PDF_OPEN_SUCCESS: 'NOTES_REQ_APPROVAL_PDF_OPEN_SUCCESS',
    NOTES_REQ_APPROVAL_PDF_OPEN_FAILURE: 'NOTES_REQ_APPROVAL_PDF_OPEN_FAILURE',
    NOTE_ADD_STG_FLAG_REQUEST: 'NOTE_ADD_STG_FLAG_REQUEST',
    NOTE_ADD_STG_FLAG_SUCCESS: 'NOTE_ADD_STG_FLAG_SUCCESS',
    NOTE_ADD_STG_FLAG_FAILURE: 'NOTE_ADD_STG_FLAG_FAILURE',
    NOTES_PENDING_ACTION_LOAD_REQUEST: 'NOTES_PENDING_ACTION_LOAD_REQUEST',
    NOTES_PENDING_ACTION_LOAD_SUCCESS: 'NOTES_PENDING_ACTION_LOAD_SUCCESS',
    NOTES_PENDING_ACTION_LOAD_FAILURE: 'NOTES_PENDING_ACTION_LOAD_FAILURE',
    NOTES_PENDING_ACTION_DELETE_ALL_REQUEST: 'NOTES_PENDING_ACTION_DELETE_ALL_REQUEST',
    NOTES_PENDING_ACTION_DELETE_ALL_SUCCESS: 'NOTES_PENDING_ACTION_DELETE_ALL_SUCCESS',
    NOTES_PENDING_ACTION_DELETE_ALL_FAILURE: 'NOTES_PENDING_ACTION_DELETE_ALL_FAILURE',
    NOTES_PENDING_ACTION_SET_SELECTED_MESSAGE: 'NOTES_PENDING_ACTION_SET_SELECTED_MESSAGE',
    NOTES_PENDING_ACTION_MARK_READ_REQUEST: 'NOTES_PENDING_ACTION_MARK_READ_REQUEST',
    NOTES_PENDING_ACTION_MARK_READ_SUCCESS: 'NOTES_PENDING_ACTION_MARK_READ_SUCCESS',
    NOTES_PENDING_ACTION_MARK_READ_FAILURE: 'NOTES_PENDING_ACTION_MARK_READ_FAILURE',
    NOTES_PENDING_ACTION_DELETE_REQUEST: 'NOTES_PENDING_ACTION_DELETE_REQUEST',
    NOTES_PENDING_ACTION_DELETE_SUCCESS: 'NOTES_PENDING_ACTION_DELETE_SUCCESS',
    NOTES_PENDING_ACTION_DELETE_FAILURE: 'NOTES_PENDING_ACTION_DELETE_FAILURE',

    PN_DUE_LOAD_REQUEST: 'PN_DUE_LOAD_REQUEST',
    PN_DUE_LOAD_SUCCESS: 'PN_DUE_LOAD_SUCCESS',
    PN_DUE_LOAD_FAILURE: 'PN_DUE_LOAD_FAILURE',
    PN_DUE_MARK_READ_REQUEST: 'PN_DUE_MARK_READ_REQUEST',
    PN_DUE_MARK_READ_SUCCESS: 'PN_DUE_MARK_READ_SUCCESS',
    PN_DUE_MARK_READ_FAILURE: 'PN_DUE_MARK_READ_FAILURE',
    PN_DUE_LOAD_DETAILS_REQUEST: 'PN_DUE_LOAD_DETAILS_REQUEST',
    PN_DUE_LOAD_DETAILS_SUCCESS: 'PN_DUE_LOAD_DETAILS_SUCCESS',
    PN_DUE_LOAD_DETAILS_FAILURE: 'PN_DUE_LOAD_DETAILS_FAILURE',
    PN_DUE_SET_SELECTED_MESSAGE: 'PN_DUE_SET_SELECTED_MESSAGE',
    PN_DUE_CLEAR_SELECTION: 'PN_DUE_CLEAR_SELECTION',

    DC_DUE_LOAD_REQUEST: 'DC_DUE_LOAD_REQUEST',
    DC_DUE_LOAD_SUCCESS: 'DC_DUE_LOAD_SUCCESS',
    DC_DUE_LOAD_FAILURE: 'DC_DUE_LOAD_FAILURE',
    DC_DUE_MARK_READ_REQUEST: 'DC_DUE_MARK_READ_REQUEST',
    DC_DUE_MARK_READ_SUCCESS: 'DC_DUE_MARK_READ_SUCCESS',
    DC_DUE_MARK_READ_FAILURE: 'DC_DUE_MARK_READ_FAILURE',
    DC_DUE_SET_SELECTED_MESSAGE: 'DC_DUE_SET_SELECTED_MESSAGE',
    DC_DUE_CLEAR_SELECTION: 'DC_DUE_CLEAR_SELECTION',

    SPEC_PROG_REQS_LOAD_REQUEST: 'SPEC_PROG_REQS_LOAD_REQUEST',
    SPEC_PROG_REQS_LOAD_SUCCESS: 'SPEC_PROG_REQS_LOAD_SUCCESS',
    SPEC_PROG_REQS_LOAD_FAILURE: 'SPEC_PROG_REQS_LOAD_FAILURE',
    SPEC_PROG_REQS_SET_SELECTED_MESSAGE: 'SPEC_PROG_REQS_SET_SELECTED_MESSAGE',
    SPEC_PROG_REQS_MARK_READ_REQUEST: 'SPEC_PROG_REQS_MARK_READ_REQUEST',
    SPEC_PROG_REQS_MARK_READ_SUCCESS: 'SPEC_PROG_REQS_MARK_READ_SUCCESS',
    SPEC_PROG_REQS_MARK_READ_FAILURE: 'SPEC_PROG_REQS_MARK_READ_FAILURE',
    SPEC_PROG_REQS_REPLY_REQUEST: 'SPEC_PROG_REQS_REPLY_REQUEST',
    SPEC_PROG_REQS_REPLY_SUCCESS: 'SPEC_PROG_REQS_REPLY_SUCCESS',
    SPEC_PROG_REQS_REPLY_FAILURE: 'SPEC_PROG_REQS_REPLY_FAILURE',
    SPEC_PROG_REQS_TOGGLE_REPLY: 'SPEC_PROG_REQS_TOGGLE_REPLY',

    FED_REV_LOAD_REQUEST: 'FED_REV_LOAD_REQUEST',
    FED_REV_LOAD_SUCCESS: 'FED_REV_LOAD_SUCCESS',
    FED_REV_LOAD_FAILURE: 'FED_REV_LOAD_FAILURE',
    FED_REV_SET_SELECTED_MESSAGE: 'FED_REV_SET_SELECTED_MESSAGE',
    FED_REV_MARK_READ_REQUEST: 'FED_REV_MARK_READ_REQUEST',
    FED_REV_MARK_READ_SUCCESS: 'FED_REV_MARK_READ_SUCCESS',
    FED_REV_MARK_READ_FAILURE: 'FED_REV_MARK_READ_FAILURE',
    FED_REV_REPLY_REQUEST: 'FED_REV_REPLY_REQUEST',
    FED_REV_REPLY_SUCCESS: 'FED_REV_REPLY_SUCCESS',
    FED_REV_REPLY_FAILURE: 'FED_REV_REPLY_FAILURE',
    FED_REV_TOGGLE_REPLY: 'FED_REV_TOGGLE_REPLY',
    FED_REV_CLOSE_NOTIFICATION_REQUEST: 'FED_REV_CLOSE_NOTIFICATION_REQUEST',
    FED_REV_CLOSE_NOTIFICATION_SUCCESS: 'FED_REV_CLOSE_NOTIFICATION_SUCCESS',
    FED_REV_CLOSE_NOTIFICATION_FAILURE: 'FED_REV_CLOSE_NOTIFICATION_FAILURE',
    LOGIN_REQUEST: 'LOGIN_REQUEST',
    LOGIN_SUCCESS: 'LOGIN_SUCCESS',
    LOGIN_FAILURE: 'LOGIN_FAILURE',
    FORCE_REFRESH: 'FORCE_REFRESH',
    NO_REFRESH: 'NO_REFRESH',
    LOGOUT_REQUEST: 'LOGOUT_REQUEST',
    LOGOUT_SUCCESS: 'LOGOUT_SUCCESS',
    LOGOUT_FAILURE: 'LOGOUT_FAILURE',
    SELECT_COMPANY_REQUEST: 'SELECT_COMPANY_REQUEST',
    SELECT_COMPANY_SUCCESS: 'SELECT_COMPANY_SUCCESS',
    SELECT_COMPANY_FAILURE: 'SELECT_COMPANY_FAILURE',
    SAVE_SESSION_REQUEST: 'SAVE_SESSION_REQUEST',
    SAVE_SESSION_SUCCESS: 'SAVE_SESSION_SUCCESS',
    SAVE_SESSION_FAILURE: 'SAVE_SESSION_FAILURE',
    LOAD_SESSION_REQUEST: 'LOAD_SESSION_REQUEST',
    LOAD_SESSION_SUCCESS: 'LOAD_SESSION_SUCCESS',
    LOAD_SESSION_FAILURE: 'LOAD_SESSION_FAILURE',
    CETS_PUNCH_IN_REQUEST: 'CETS_PUNCH_IN_REQUEST',
    CETS_PUNCH_IN_SUCCESS: 'CETS_PUNCH_IN_SUCCESS',
    CETS_PUNCH_IN_FAILURE: 'CETS_PUNCH_IN_FAILURE',
    CETS_CLEAR_MESSAGE: 'CETS_CLEAR_MESSAGE',
    MASTER_DATA_LOAD_REQUEST: 'MASTER_DATA_LOAD_REQUEST',
    MASTER_DATA_LOAD_SUCCESS: 'MASTER_DATA_LOAD_SUCCESS',
    MASTER_DATA_LOAD_FAILURE: 'MASTER_DATA_LOAD_FAILURE',
    SEARCH_QUICK_REQUEST: 'SEARCH_QUICK_REQUEST',
    SEARCH_QUICK_SUCCESS: 'SEARCH_QUICK_SUCCESS',
    SEARCH_QUICK_FAILURE: 'SEARCH_QUICK_FAILURE',
    SEARCH_QUICK_TYPED: 'SEARCH_QUICK_TYPED',
    SEARCH_QUICK_CLEAR: 'SEARCH_QUICK_CLEAR',
    SEARCH_UPDATED: 'SEARCH_UPDATED',
    SEARCH_REQUEST: 'SEARCH_REQUEST',
    SEARCH_SUCCESS: 'SEARCH_SUCCESS',
    SEARCH_FAILURE: 'SEARCH_FAILURE',
    SEARCH_TYPED: 'SEARCH_TYPED',
    SEARCH_CLEAR: 'SEARCH_CLEAR',
    PATIENT_OPEN_REQUEST: 'PATIENT_OPEN_REQUEST',
    PATIENT_OPEN_SUCCESS: 'PATIENT_OPEN_SUCCESS',
    PATIENT_OPEN_FAILURE: 'PATIENT_OPEN_FAILURE',
    PATIENT_LOAD_REQUEST: 'PATIENT_LOAD_REQUEST',
    PATIENT_LOAD_SUCCESS: 'PATIENT_LOAD_SUCCESS',
    PATIENT_LOAD_FAILURE: 'PATIENT_LOAD_FAILURE',
    PATIENT_USE_PEDS_REQUEST: 'PATIENT_USE_PEDS_REQUEST',
    PATIENT_USE_PEDS_SUCCESS: 'PATIENT_USE_PEDS_SUCCESS',
    PATIENT_USE_PEDS_FAILURE: 'PATIENT_USE_PEDS_FAILURE',
    PATIENT_SET_ACTIVE: 'PATIENT_SET_ACTIVE',
    PATIENT_CLOSE: 'PATIENT_CLOSE',
    PATIENT_CLOSE_SUCCESS: 'PATIENT_CLOSE_SUCCESS',
    PATIENT_SET_TAB_ACTIVE_REQUEST: 'PATIENT_SET_TAB_ACTIVE_REQUEST',
    PATIENT_SET_TAB_ACTIVE_SUCCESS: 'PATIENT_SET_TAB_ACTIVE_SUCCESS',
    PATIENT_SET_TAB_ACTIVE_FAILURE: 'PATIENT_SET_TAB_ACTIVE_FAILURE',
    PATIENT_CLOSE_TAB: 'PATIENT_CLOSE_TAB',
    PATIENT_UPDATE_NOTES_REQUEST: 'PATIENT_UPDATE_NOTES_REQUEST',
    PATIENT_UPDATE_NOTES_SUCCESS: 'PATIENT_UPDATE_NOTES_SUCCESS',
    PATIENT_UPDATE_NOTES_FAILURE: 'PATIENT_UPDATE_NOTES_FAILURE',
    PATIENT_REFRESH_ADMISSIONS_REQUEST: 'PATIENT_REFRESH_ADMISSIONS_REQUEST',
    PATIENT_REFRESH_ADMISSIONS_SUCCESS: 'PATIENT_REFRESH_ADMISSIONS_SUCCESS',
    PATIENT_REFRESH_ADMISSIONS_FAILURE: 'PATIENT_REFRESH_ADMISSIONS_FAILURE',
    PATIENT_REFRESH_SCANS_REQUEST: 'PATIENT_REFRESH_SCANS_REQUEST',
    PATIENT_REFRESH_SCANS_SUCCESS: 'PATIENT_REFRESH_SCANS_SUCCESS',
    PATIENT_REFRESH_SCANS_FAILURE: 'PATIENT_REFRESH_SCANS_FAILURE',
    PATIENT_UPDATE_CONTRAIN_REQUEST: 'PATIENT_UPDATE_CONTRAIN_REQUEST',
    PATIENT_UPDATE_CONTRAIN_SUCCESS: 'PATIENT_UPDATE_CONTRAIN_SUCCESS',
    PATIENT_UPDATE_CONTRAIN_FAILURE: 'PATIENT_UPDATE_CONTRAIN_FAILURE',
    PATIENT_ENABLE_RTM_REQUEST: 'PATIENT_ENABLE_RTM_REQUEST',
    PATIENT_ENABLE_RTM_SUCCESS: 'PATIENT_ENABLE_RTM_SUCCESS',
    PATIENT_ENABLE_RTM_FAILURE: 'PATIENT_ENABLE_RTM_FAILURE',
    PATIENT_CATEGORY_CHANGE: 'PATIENT_CATEGORY_CHANGE',
    PATIENT_ADMISSION_VISIBILITY_TOGGLE: 'PATIENT_ADMISSION_VISIBILITY_TOGGLE',
    PATIENT_CDV_VISIBILITY_TOGGLE: 'PATIENT_CDV_VISIBILITY_TOGGLE',
    PATIENT_FOTO_PANEL_VISIBILITY_TOGGLE: 'PATIENT_FOTO_PANEL_VISIBILITY_TOGGLE',
    PATIENT_RTM_VISIBILITY_TOGGLE: 'PATIENT_RTM_VISIBILITY_TOGGLE',
    PATIENT_BENEFIT_VISIBILITY_TOGGLE: 'PATIENT_BENEFIT_VISIBILITY_TOGGLE',
    PATIENT_PDF_OPEN_REQUEST: 'PATIENT_PDF_OPEN_REQUEST',
    PATIENT_PDF_OPEN_SUCCESS: 'PATIENT_PDF_OPEN_SUCCESS',
    PATIENT_PDF_OPEN_FAILURE: 'PATIENT_PDF_OPEN_FAILURE',
    PATIENT_PDF_LOAD_REQUEST: 'PATIENT_PDF_LOAD_REQUEST',
    PATIENT_PDF_LOAD_SUCCESS: 'PATIENT_PDF_LOAD_SUCCESS',
    PATIENT_PDF_LOAD_FAILURE: 'PATIENT_PDF_LOAD_FAILURE',
    PATIENT_AL_OPEN_REQUEST: 'PATIENT_AL_OPEN_REQUEST',
    PATIENT_AL_OPEN_SUCCESS: 'PATIENT_AL_OPEN_SUCCESS',
    PATIENT_AL_OPEN_FAILURE: 'PATIENT_AL_OPEN_FAILURE',
    PATIENT_AL_LOAD_REQUEST: 'PATIENT_AL_LOAD_REQUEST',
    PATIENT_AL_LOAD_SUCCESS: 'PATIENT_AL_LOAD_SUCCESS',
    PATIENT_AL_LOAD_FAILURE: 'PATIENT_AL_LOAD_FAILURE',
    PATIENT_AL_DISPLAY_MODE_CHANGE: 'PATIENT_AL_DISPLAY_MODE_CHANGE',
    PATIENT_DIARY_LOAD_REQUEST: 'DIARY_LOAD_REQUEST',
    PATIENT_DIARY_LOAD_SUCCESS: 'DIARY_LOAD_SUCCESS',
    PATIENT_DIARY_LOAD_FAILURE: 'DIARY_LOAD_FAILURE',
    PATIENT_APPT_HIST_FILTER: 'PATIENT_APPT_HIST_FILTER',
    PATIENT_APPT_HIST_START_DATE: 'PATIENT_APPT_HIST_START_DATE',
    PATIENT_APPT_HIST_END_DATE: 'PATIENT_APPT_HIST_END_DATE',
    PATIENT_APPT_HIST_SORT: 'PATIENT_APPT_HIST_SORT',
    PATIENT_PEER_REVIEW_VISIBILITY_TOGGLE: 'PATIENT_PEER_REVIEW_VISIBILITY_TOGGLE',
    PATIENT_SHOW_SPECIAL_PROG_REQ: 'PATIENT_SHOW_SPECIAL_PROG_REQ',
    PATIENT_HIDE_SPECIAL_PROG_REQ: 'PATIENT_HIDE_SPECIAL_PROG_REQ',
    PATIENT_SAVE_SPECIAL_PROG_REQ_REQUEST: 'PATIENT_SAVE_SPECIAL_PROG_REQ_REQUEST',
    PATIENT_SAVE_SPECIAL_PROG_REQ_SUCCESS: 'PATIENT_SAVE_SPECIAL_PROG_REQ_SUCCESS',
    PATIENT_SAVE_SPECIAL_PROG_REQ_FAILURE: 'PATIENT_SAVE_SPECIAL_PROG_REQ_FAILURE',
    PATIENT_PEER_REVIEWS_LOAD_REQUEST: 'PATIENT_PEER_REVIEWS_LOAD_REQUEST',
    PATIENT_PEER_REVIEWS_LOAD_SUCCESS: 'PATIENT_PEER_REVIEWS_LOAD_SUCCESS',
    PATIENT_PEER_REVIEWS_LOAD_FAILURE: 'PATIENT_PEER_REVIEWS_LOAD_FAILURE',
    PATIENT_ADD_DIAG_REQUEST: 'PATIENT_ADD_DIAG_REQUEST',
    PATIENT_ADD_DIAG_SUCCESS: 'PATIENT_ADD_DIAG_SUCCESS',
    PATIENT_ADD_DIAG_FAILURE: 'PATIENT_ADD_DIAG_FAILURE',
    PATIENT_REMOVE_DIAG_REQUEST: 'PATIENT_REMOVE_DIAG_REQUEST',
    PATIENT_REMOVE_DIAG_SUCCESS: 'PATIENT_REMOVE_DIAG_SUCCESS',
    PATIENT_REMOVE_DIAG_FAILURE: 'PATIENT_REMOVE_DIAG_FAILURE',
    PATIENT_COPY_ALL_DIAG_REQUEST: 'PATIENT_COPY_ALL_DIAG_REQUEST',
    PATIENT_COPY_ALL_DIAG_SUCCESS: 'PATIENT_COPY_ALL_DIAG_SUCCESS',
    PATIENT_COPY_ALL_DIAG_FAILURE: 'PATIENT_COPY_ALL_DIAG_FAILURE',
    PATIENT_UPDATE_DIAG_ONSET_REQUEST: 'PATIENT_UPDATE_DIAG_ONSET_REQUEST',
    PATIENT_UPDATE_DIAG_ONSET_SUCCESS: 'PATIENT_UPDATE_DIAG_ONSET_SUCCESS',
    PATIENT_UPDATE_DIAG_ONSET_FAILURE: 'PATIENT_UPDATE_DIAG_ONSET_FAILURE',
    PATIENT_POC_LOAD_REQUEST: 'PATIENT_POC_LOAD_REQUEST',
    PATIENT_POC_LOAD_SUCCESS: 'PATIENT_POC_LOAD_SUCCESS',
    PATIENT_POC_LOAD_FAILURE: 'PATIENT_POC_LOAD_FAILURE',
    PATIENT_OPEN_HEP_REQUEST: 'PATIENT_OPEN_HEP_REQUEST',
    PATIENT_OPEN_HEP_SUCCESS: 'PATIENT_OPEN_HEP_SUCCESS',
    PATIENT_OPEN_HEP_FAILURE: 'PATIENT_OPEN_HEP_FAILURE',
    PATIENT_CREATE_RTM_NOTE_REQUEST: 'PATIENT_CREATE_RTM_NOTE_REQUEST',
    PATIENT_CREATE_RTM_NOTE_SUCCESS: 'PATIENT_CREATE_RTM_NOTE_SUCCESS',
    PATIENT_CREATE_RTM_NOTE_FAILURE: 'PATIENT_CREATE_RTM_NOTE_FAILURE',


    FOTO_EPISODES_LOAD_REQUEST: 'FOTO_EPISODES_LOAD_REQUEST',
    FOTO_EPISODES_LOAD_SUCCESS: 'FOTO_EPISODES_LOAD_SUCCESS',
    FOTO_EPISODES_LOAD_FAILURE: 'FOTO_EPISODES_LOAD_FAILURE',
    FOTO_RESPONCE_REFRESH_SUCCESS: 'FOTO_RESPONCE_REFRESH_SUCCESS',
    FOTO_RESPONCE_MESSURE_REFRESH_SUCCESS: 'FOTO_RESPONCE_MESSURE_REFRESH_SUCCESS',
    FOTO_EPISODES_FOR_PATIENT_REFRESH_REQUEST: 'FOTO_EPISODES_FOR_PATIENT_REFRESH_REQUEST',
    FOTO_EPISODES_FOR_PATIENT_REFRESH_SUCCESS: 'FOTO_EPISODES_FOR_PATIENT_REFRESH_SUCCESS',
    FOTO_EPISODES_FOR_PATIENT_REFRESH_FAILURE: 'FOTO_EPISODES_FOR_PATIENT_REFRESH_FAILURE',
    FOTO_EPISODES_REFRESH_REQUEST: 'FOTO_EPISODES_REFRESH_REQUEST',
    FOTO_EPISODES_REFRESH_SUCCESS: 'FOTO_EPISODES_REFRESH_SUCCESS',
    FOTO_EPISODES_REFRESH_FAILURE: 'FOTO_EPISODES_REFRESH_FAILURE',
    FOTO_CLAIM_STATUS_CHANGE_REQUEST: 'FOTO_CLAIM_STATUS_CHANGE_REQUEST',
    FOTO_CLAIM_STATUS_CHANGE_SUCCESS: 'FOTO_CLAIM_STATUS_CHANGE_SUCCESS',
    FOTO_CLAIM_STATUS_CHANGE_FAILURE: 'FOTO_CLAIM_STATUS_CHANGE_FAILURE',
    NOTE_SHOW_ADDENDUM: 'NOTE_SHOW_ADDENDUM',
    NOTE_HIDE_ADDENDUM: 'NOTE_HIDE_ADDENDUM',
    NOTE_SHOW_SCRIBE: 'NOTE_SHOW_SCRIBE',
    NOTE_HIDE_SCRIBE: 'NOTE_HIDE_SCRIBE',
    NOTE_SHOW_CHARGE_ADDENDUM_QUESTION: 'NOTE_SHOW_CHARGE_ADDENDUM_QUESTION',
    NOTE_HIDE_CHARGE_ADDENDUM_QUESTION: 'NOTE_HIDE_CHARGE_ADDENDUM_QUESTION',
    NOTE_SHOW_CHARGE_ADDENDUM: 'NOTE_SHOW_CHARGE_ADDENDUM',
    NOTE_HIDE_CHARGE_ADDENDUM: 'NOTE_HIDE_CHARGE_ADDENDUM',
    NOTE_SAVE_ADDENDUM_REQUEST: 'NOTE_SAVE_ADDENDUM_REQUEST',
    NOTE_SAVE_ADDENDUM_SUCCESS: 'NOTE_SAVE_ADDENDUM_SUCCESS',
    NOTE_SAVE_ADDENDUM_FAILURE: 'NOTE_SAVE_ADDENDUM_FAILURE',
    NOTE_SAVE_CHARGE_ADDENDUM_REQUEST: 'NOTE_SAVE_CHARGE_ADDENDUM_REQUEST',
    NOTE_SAVE_CHARGE_ADDENDUM_SUCCESS: 'NOTE_SAVE_CHARGE_ADDENDUM_SUCCESS',
    NOTE_SAVE_CHARGE_ADDENDUM_FAILURE: 'NOTE_SAVE_CHARGE_ADDENDUM_FAILURE',
    NOTE_DELETE_REQUEST: 'NOTE_DELETE_REQUEST',
    NOTE_DELETE_SUCCESS: 'NOTE_DELETE_SUCCESS',
    NOTE_DELETE_FAILURE: 'NOTE_DELETE_FAILURE',
    NOTE_REOPEN_REQUEST: 'NOTE_REOPEN_REQUEST',
    NOTE_REOPEN_SUCCESS: 'NOTE_REOPEN_SUCCESS',
    NOTE_REOPEN_FAILURE: 'NOTE_REOPEN_FAILURE',
    NOTE_START_REQUEST: 'NOTE_START_REQUEST',
    NOTE_START_SUCCESS: 'NOTE_START_SUCCESS',
    NOTE_START_FAILURE: 'NOTE_START_FAILURE',
    NOTE_START_FAILURE_DISC: 'NOTE_START_FAILURE_DISC',
    NOTE_START_FAILURE_PERM: 'NOTE_START_FAILURE_PERM',
    NOTE_START_EVAL_OPTIONS: 'NOTE_START_EVAL_OPTIONS',
    NOTE_START_EVAL_OPTIONS_PEDS: 'NOTE_START_EVAL_OPTIONS_PEDS',
    NOTE_START_EVAL_OPTIONS_CLEAR: 'NOTE_START_EVAL_OPTIONS_CLEAR',
    NOTE_START_WARNING: 'NOTE_START_WARNING',
    NOTE_START_WARNINGS: 'NOTE_START_WARNINGS',
    NOTE_START_WARNINGS_CLEAR: 'NOTE_START_WARNINGS_CLEAR',
    NOTE_START_WARNING_CLEAR: 'NOTE_START_WARNING_CLEAR',
    NOTE_IN_PROG_OPEN_REQUEST: 'NOTE_IN_PROG_OPEN_REQUEST',
    NOTE_IN_PROG_OPEN_SUCCESS: 'NOTE_IN_PROG_OPEN_SUCCESS',
    NOTE_IN_PROG_OPEN_FAILURE: 'NOTE_IN_PROG_OPEN_FAILURE',
    NOTE_IN_PROG_LOAD_REQUEST: 'NOTE_IN_PROG_LOAD_REQUEST',
    NOTE_IN_PROG_LOAD_SUCCESS: 'NOTE_IN_PROG_LOAD_SUCCESS',
    NOTE_IN_PROG_LOAD_FAILURE: 'NOTE_IN_PROG_LOAD_FAILURE',
    NOTE_TOGGLE_SECTION_VISIBILITY: 'NOTE_TOGGLE_SECTION_VISIBILITY',
    NOTE_SET_NO_CHARGES_VISIBLE: 'NOTE_SET_NO_CHARGES_VISIBLE',
    NOTE_UPDATE_TEXT_FIELD_REQUEST: 'NOTE_UPDATE_TEXT_FIELD_REQUEST',
    NOTE_UPDATE_TEXT_FIELD_SUCCESS: 'NOTE_UPDATE_TEXT_FIELD_SUCCESS',
    NOTE_UPDATE_TEXT_FIELD_FAILURE: 'NOTE_UPDATE_TEXT_FIELD_FAILURE',
    NOTE_UPDATE_TIME_FIELD_REQUEST: 'NOTE_UPDATE_TIME_FIELD_REQUEST',
    NOTE_UPDATE_TIME_FIELD_SUCCESS: 'NOTE_UPDATE_TIME_FIELD_SUCCESS',
    NOTE_UPDATE_TIME_FIELD_FAILURE: 'NOTE_UPDATE_TIME_FIELD_FAILURE',
    NOTE_UPDATE_BIT_FIELD_REQUEST: 'NOTE_UPDATE_BIT_FIELD_REQUEST',
    NOTE_UPDATE_BIT_FIELD_SUCCESS: 'NOTE_UPDATE_BIT_FIELD_SUCCESS',
    NOTE_UPDATE_BIT_FIELD_FAILURE: 'NOTE_UPDATE_BIT_FIELD_FAILURE',
    NOTE_UPDATE_INT_FIELD_REQUEST: 'NOTE_UPDATE_INT_FIELD_REQUEST',
    NOTE_UPDATE_INT_FIELD_SUCCESS: 'NOTE_UPDATE_INT_FIELD_SUCCESS',
    NOTE_UPDATE_INT_FIELD_FAILURE: 'NOTE_UPDATE_INT_FIELD_FAILURE',
    AL_UPDATE_TIME_REQUEST: 'AL_UPDATE_TIME_REQUEST',
    AL_UPDATE_TIME_SUCCESS: 'AL_UPDATE_TIME_SUCCESS',
    AL_UPDATE_TIME_FAILURE: 'AL_UPDATE_TIME_FAILURE',
    NOTE_UPDATE_DECIMAL_FIELD_REQUEST: 'NOTE_UPDATE_DECIMAL_FIELD_REQUEST',
    NOTE_UPDATE_DECIMAL_FIELD_SUCCESS: 'NOTE_UPDATE_DECIMAL_FIELD_SUCCESS',
    NOTE_UPDATE_DECIMAL_FIELD_FAILURE: 'NOTE_UPDATE_DECIMAL_FIELD_FAILURE',
    NOTE_UPDATE_DATE_FIELD_REQUEST: 'NOTE_UPDATE_DATE_FIELD_REQUEST',
    NOTE_UPDATE_DATE_FIELD_SUCCESS: 'NOTE_UPDATE_DATE_FIELD_SUCCESS',
    NOTE_UPDATE_DATE_FIELD_FAILURE: 'NOTE_UPDATE_DATE_FIELD_FAILURE',
    NOTE_UPDATE_CONTRAIN_REQUEST: 'NOTE_UPDATE_CONTRAIN_REQUEST',
    NOTE_UPDATE_CONTRAIN_SUCCESS: 'NOTE_UPDATE_CONTRAIN_SUCCESS',
    NOTE_UPDATE_CONTRAIN_FAILURE: 'NOTE_UPDATE_CONTRAIN_FAILURE',
    NOTE_CLEAR_FIELD_REQUEST: 'NOTE_CLEAR_FIELD_REQUEST',
    NOTE_CLEAR_FIELD_SUCCESS: 'NOTE_CLEAR_FIELD_SUCCESS',
    NOTE_CLEAR_FIELD_FAILURE: 'NOTE_CLEAR_FIELD_FAILURE',
    NOTE_CLEAR_FIELDS_REQUEST: 'NOTE_CLEAR_FIELDS_REQUEST',
    NOTE_CLEAR_FIELDS_SUCCESS: 'NOTE_CLEAR_FIELDS_SUCCESS',
    NOTE_CLEAR_FIELDS_FAILURE: 'NOTE_CLEAR_FIELDS_FAILURE',
    NOTE_CLEAR_SPINE_FIELDS_REQUEST: 'NOTE_CLEAR_SPINE_FIELDS_REQUEST',
    NOTE_CLEAR_SPINE_FIELDS_SUCCESS: 'NOTE_CLEAR_SPINE_FIELDS_SUCCESS',
    NOTE_CLEAR_SPINE_FIELDS_FAILURE: 'NOTE_CLEAR_SPINE_FIELDS_FAILURE',
    NOTE_ADD_TEMPLATE_REQUEST: 'NOTE_ADD_TEMPLATE_REQUEST',
    NOTE_ADD_TEMPLATE_SUCCESS: 'NOTE_ADD_TEMPLATE_SUCCESS',
    NOTE_ADD_TEMPLATE_FAILURE: 'NOTE_ADD_TEMPLATE_FAILURE',
    NOTE_REMOVE_TEMPLATE_REQUEST: 'NOTE_REMOVE_TEMPLATE_REQUEST',
    NOTE_REMOVE_TEMPLATE_SUCCESS: 'NOTE_REMOVE_TEMPLATE_SUCCESS',
    NOTE_REMOVE_TEMPLATE_FAILURE: 'NOTE_REMOVE_TEMPLATE_FAILURE',
    NOTE_ADD_CHILD_ROW_REQUEST: 'NOTE_ADD_CHILD_ROW_REQUEST',
    NOTE_ADD_CHILD_ROW_SUCCESS: 'NOTE_ADD_CHILD_ROW_SUCCESS',
    NOTE_ADD_CHILD_ROW_FAILURE: 'NOTE_ADD_CHILD_ROW_FAILURE',
    NOTE_ADD_CUSTOM_GOAL_REQUEST: 'NOTE_ADD_CUSTOM_GOAL_REQUEST',
    NOTE_ADD_CUSTOM_GOAL_SUCCESS: 'NOTE_ADD_CUSTOM_GOAL_SUCCESS',
    NOTE_ADD_CUSTOM_GOAL_FAILURE: 'NOTE_ADD_CUSTOM_GOAL_FAILURE',
    NOTE_ADD_IND_HEP_GOAL_REQUEST: 'NOTE_ADD_IND_HEP_GOAL_REQUEST',
    NOTE_ADD_IND_HEP_GOAL_SUCCESS: 'NOTE_ADD_IND_HEP_GOAL_SUCCESS',
    NOTE_ADD_IND_HEP_GOAL_FAILURE: 'NOTE_ADD_IND_HEP_GOAL_FAILURE',
    NOTE_ADD_CHILD_ROW_GENERATOR_REQUEST: 'NOTE_ADD_CHILD_ROW_REQUEST',
    NOTE_ADD_CHILD_ROW_GENERATOR_SUCCESS: 'NOTE_ADD_CHILD_ROW_SUCCESS',
    NOTE_ADD_CHILD_ROW_GENERATOR_FAILURE: 'NOTE_ADD_CHILD_ROW_FAILURE',
    NOTE_ADD_AL_ROW_REQUEST: 'NOTE_ADD_AL_ROW_REQUEST',
    NOTE_ADD_AL_ROW_SUCCESS: 'NOTE_ADD_AL_ROW_SUCCESS',
    NOTE_ADD_AL_ROW_FAILURE: 'NOTE_ADD_AL_ROW_FAILURE',
    NOTE_REMOVE_CHILD_ROW_REQUEST: 'NOTE_REMOVE_CHILD_ROW_REQUEST',
    NOTE_REMOVE_CHILD_ROW_SUCCESS: 'NOTE_REMOVE_CHILD_ROW_SUCCESS',
    NOTE_REMOVE_CHILD_ROW_FAILURE: 'NOTE_REMOVE_CHILD_ROW_FAILURE',
    EVAL_TRANSFER_REQUEST: 'EVAL_TRANSFER_REQUEST',
    EVAL_TRANSFER_SUCCESS: 'EVAL_TRANSFER_SUCCESS',
    EVAL_TRANSFER_FAILURE: 'EVAL_TRANSFER_FAILURE',
    EVAL_PREPOPULATE_REQUEST: 'EVAL_PREPOPULATE_REQUEST',
    EVAL_PREPOPULATE_SUCCESS: 'EVAL_PREPOPULATE_SUCCESS',
    EVAL_PREPOPULATE_FAILURE: 'EVAL_PREPOPULATE_FAILURE',
    EVAL_START_BLANK_REQUEST: 'EVAL_START_BLANK_REQUEST',
    EVAL_START_BLANK_SUCCESS: 'EVAL_START_BLANK_SUCCESS',
    EVAL_START_BLANK_FAILURE: 'EVAL_START_BLANK_FAILURE',
    CDV_TOGGLE_CLINICAL: 'CDV_TOGGLE_CLINICAL',
    CDV_TOGGLE_FOTO: 'CDV_TOGGLE_FOTO',
    DIARY_SHOW: 'DIARY_SHOW',
    DIARY_HIDE: 'DIARY_HIDE',
    SCRIBE_SHOW: 'SCRIBE_SHOW',
    SCRIBE_HIDE: 'SCRIBE_HIDE',
    SCRIBE_OPTIONS_SHOW: 'SCRIBE_OPTIONS_SHOW',
    SCRIBE_OPTIONS_HIDE: 'SCRIBE_OPTIONS_HIDE',
    DIARY_SAVE_REQUEST: 'DIARY_SAVE_REQUEST',
    DIARY_SAVE_SUCCESS: 'DIARY_SAVE_SUCCESS',
    DIARY_SAVE_FAILURE: 'DIARY_SAVE_FAILURE',
    DIARY_TOGGLE_ISSUE: 'DIARY_TOGGLE_ISSUE',
    DIARY_LOAD_REQUEST: 'DIARY_LOAD_REQUEST',
    DIARY_LOAD_SUCCESS: 'DIARY_LOAD_SUCCESS',
    DIARY_LOAD_FAILURE: 'DIARY_LOAD_FAILURE',
    DIARY_SET_SELECTED_MESSAGE: 'DIARY_SET_SELECTED_MESSAGE',
    DIARY_MARK_READ_REQUEST: 'DIARY_MARK_READ_REQUEST',
    DIARY_MARK_READ_SUCCESS: 'DIARY_MARK_READ_SUCCESS',
    DIARY_MARK_READ_FAILURE: 'DIARY_MARK_READ_FAILURE',
    DIARY_RESOLVE_REQUEST: 'DIARY_RESOLVE_REQUEST',
    DIARY_RESOLVE_SUCCESS: 'DIARY_RESOLVE_SUCCESS',
    DIARY_RESOLVE_FAILURE: 'DIARY_RESOLVE_FAILURE',
    DIARY_TOGGLE_RESOLVE: 'DIARY_TOGGLE_RESOLVE',
    CDV_REFRESH_REQUEST: 'CDV_REFRESH_REQUEST',
    CDV_REFRESH_SUCCESS: 'CDV_REFRESH_SUCCESS',
    CDV_REFRESH_FAILURE: 'CDV_REFRESH_FAILURE',
    SAVE_SCROLL: 'SAVE_SCROLL',
    CHANGE_ROUTE: 'CHANGE_ROUTE',
    NOTE_UPDATE_AL_MOD_FIELD_REQUEST: 'NOTE_UPDATE_AL_MOD_FIELD_REQUEST',
    NOTE_UPDATE_AL_MOD_FIELD_SUCCESS: 'NOTE_UPDATE_AL_MOD_FIELD_SUCCESS',
    NOTE_UPDATE_AL_MOD_FIELD_FAILURE: 'NOTE_UPDATE_AL_MOD_FIELD_FAILURE',
    NOTE_UPDATE_AL_OTHER_FIELD_REQUEST: 'NOTE_UPDATE_AL_OTHER_FIELD_REQUEST',
    NOTE_UPDATE_AL_OTHER_FIELD_SUCCESS: 'NOTE_UPDATE_AL_OTHER_FIELD_SUCCESS',
    NOTE_UPDATE_AL_OTHER_FIELD_FAILURE: 'NOTE_UPDATE_AL_OTHER_FIELD_FAILURE',
    NOTE_CLEAR_AL_REQUEST: 'NOTE_CLEAR_AL_REQUEST',
    NOTE_GET_WARNING_REQUEST: 'NOTE_GET_WARNING_REQUEST',
    NOTE_GET_WARNING_SUCCESS: 'NOTE_GET_WARNING_SUCCESS',
    NOTE_GET_WARNING_FAILURE: 'NOTE_GET_WARNING_FAILURE',
    ADD_GOAL_DETAILS_REQUEST: 'ADD_GOAL_DETAILS_REQUEST',
    ADD_GOAL_DETAILS_SUCCESS: 'ADD_GOAL_DETAILS_SUCCESS',
    ADD_GOAL_DETAILS_FAILURE: 'ADD_GOAL_DETAILS_FAILURE',
    GOAL_TEMPLATE_VISIBLE: 'GOAL_TEMPLATE_VISIBLE',
    NOTE_CLEAR_AL_SUCCESS: 'NOTE_CLEAR_AL_SUCCESS',
    NOTE_CLEAR_AL_FAILURE: 'NOTE_CLEAR_AL_FAILURE',
    NOTE_GET_AL_TEMPLATE_REQUEST: 'NOTE_GET_AL_TEMPLATE_REQUEST',
    NOTE_GET_AL_TEMPLATE_SUCCESS: 'NOTE_GET_AL_TEMPLATE_SUCCESS',
    NOTE_GET_AL_TEMPLATE_FAILURE: 'NOTE_GET_AL_TEMPLATE_FAILURE',
    NOTE_GET_WP_AL_TEMPLATE_REQUEST: 'NOTE_GET_WP_AL_TEMPLATE_REQUEST',
    NOTE_GET_WP_AL_TEMPLATE_SUCCESS: 'NOTE_GET_WP_AL_TEMPLATE_SUCCESS',
    NOTE_GET_WP_AL_TEMPLATE_FAILURE: 'NOTE_GET_WP_AL_TEMPLATE_FAILURE',
    NOTE_CANCEL_AL_TEMPLATE: 'NOTE_CANCEL_AL_TEMPLATE',
    NOTE_AL_TEMPLATE_TOGGLE_ALL_SELECTED: 'NOTE_AL_TEMPLATE_TOGGLE_ALL_SELECTED',
    NOTE_AL_TEMPLATE_TOGGLE_ITEM: 'NOTE_AL_TEMPLATE_TOGGLE_ITEM',
    NOTE_APPLY_AL_TEMPLATE_REQUEST: 'NOTE_APPLY_AL_TEMPLATE_REQUEST',
    NOTE_APPLY_AL_TEMPLATE_SUCCESS: 'NOTE_APPLY_AL_TEMPLATE_SUCCESS',
    NOTE_APPLY_AL_TEMPLATE_FAILURE: 'NOTE_APPLY_AL_TEMPLATE_FAILURE',
    NOTE_SAVE_AL_TEMPLATE_REQUEST: 'NOTE_SAVE_AL_TEMPLATE_REQUEST',
    NOTE_SAVE_AL_TEMPLATE_SUCCESS: 'NOTE_SAVE_AL_TEMPLATE_SUCCESS',
    NOTE_SAVE_AL_TEMPLATE_FAILURE: 'NOTE_SAVE_AL_TEMPLATE_FAILURE',
    NOTE_TOGGLE_SAVE_AL_TEMPLATE_VISIBLE: 'NOTE_TOGGLE_SAVE_AL_TEMPLATE_VISIBLE',
    NOTE_DELETE_AL_TEMPLATE_REQUEST: 'NOTE_DELETE_AL_TEMPLATE_REQUEST',
    NOTE_DELETE_AL_TEMPLATE_SUCCESS: 'NOTE_DELETE_AL_TEMPLATE_SUCCESS',
    NOTE_DELETE_AL_TEMPLATE_FAILURE: 'NOTE_DELETE_AL_TEMPLATE_FAILURE',
    NOTE_UNDO_DELETE_AL_TEMPLATE_REQUEST: 'NOTE_UNDO_DELETE_AL_TEMPLATE_REQUEST',
    NOTE_UNDO_DELETE_AL_TEMPLATE_SUCCESS: 'NOTE_UNDO_DELETE_AL_TEMPLATE_SUCCESS',
    NOTE_UNDO_DELETE_AL_TEMPLATE_FAILURE: 'NOTE_UNDO_DELETE_AL_TEMPLATE_FAILURE',
    NOTE_ADD_GOAL_REQUEST: 'NOTE_ADD_GOAL_REQUEST',
    UPDATE_LTG_DATE_REQUEST: 'UPDATE_LTG_DATE_REQUEST',
    UPDATE_LTG_DATE_SUCCESS: 'UPDATE_LTG_DATE_SUCCESS',
    UPDATE_LTG_DATE_FAILURE: 'UPDATE_LTG_DATE_FAILURE',
    UPDATE_STG_DATE_REQUEST: 'UPDATE_STG_DATE_REQUEST',
    UPDATE_STG_DATE_SUCCESS: 'UPDATE_STG_DATE_SUCCESS',
    UPDATE_STG_DATE_FAILURE: 'UPDATE_STG_DATE_FAILURE',
    UPDATE_DEFAULT_OBJ_WFL_REQUEST: 'UPDATE_DEFAULT_OBJ_WFL_REQUEST',
    UPDATE_DEFAULT_OBJ_WFL_SUCCESS: 'UPDATE_DEFAULT_OBJ_WFL_SUCCESS',
    UPDATE_DEFAULT_OBJ_WFL_FAILURE: 'UPDATE_DEFAULT_OBJ_WFL_FAILURE',
    UPDATE_DEFAULT_OBJ_HAND_WFL_REQUEST: 'UPDATE_DEFAULT_OBJ_HAND_WFL_REQUEST',
    UPDATE_DEFAULT_OBJ_HAND_WFL_SUCCESS: 'UPDATE_DEFAULT_OBJ_HAND_WFL_SUCCESS',
    UPDATE_DEFAULT_OBJ_HAND_WFL_FAILURE: 'UPDATE_DEFAULT_OBJ_HAND_WFL_FAILURE',
    UPDATE_DEF_AL_WP_PERFORMED_REQUEST: 'UPDATE_DEF_AL_WP_PERFORMED_REQUEST',
    UPDATE_DEF_AL_WP_PERFORMED_SUCCESS: 'UPDATE_DEF_AL_WP_PERFORMED_SUCCESS',
    UPDATE_DEF_AL_WP_PERFORMED_FAILURE: 'UPDATE_DEF_AL_WP_PERFORMED_FAILURE',
    NOTE_ADD_GOAL_SUCCESS: 'NOTE_ADD_GOAL_SUCCESS',
    NOTE_ADD_GOAL_FAILURE: 'NOTE_ADD_GOAL_FAILURE',
    NOTE_ADD_STGOAL_REQUEST: 'NOTE_ADD_STGOAL_REQUEST',
    NOTE_ADD_STGOAL_SUCCESS: 'NOTE_ADD_STGOAL_SUCCESS',
    NOTE_ADD_STGOAL_FAILURE: 'NOTE_ADD_STGOAL_FAILURE',
    NOTE_SET_STGDATEDEFAULT: 'NOTE_SET_STGDATEDEFAULT',
    NOTE_SELECT_GOAL: 'NOTE_SELECT_GOAL',
    NOTE_DELETE_GOAL_REQUEST: 'NOTE_DELETE_GOAL_REQUEST',
    NOTE_DELETE_GOAL_SUCCESS: 'NOTE_DELETE_GOAL_SUCCESS',
    NOTE_DELETE_GOAL_FAILURE: 'NOTE_DELETE_GOAL_FAILURE',
    NOTE_FAVORITE_GOAL_REQUEST: 'NOTE_FAVORITE_GOAL_REQUEST',
    NOTE_FAVORITE_GOAL_SUCCESS: 'NOTE_FAVORITE_GOAL_SUCCESS',
    NOTE_FAVORITE_GOAL_FAILURE: 'NOTE_FAVORITE_GOAL_FAILURE',
    NOTE_TOGGLE_FAVORITE_GOAL_VISIBLE: 'NOTE_TOGGLE_FAVORITE_GOAL_VISIBLE',
    NOTE_APPLY_FAVORITE_GOAL_REQUEST: 'NOTE_APPLY_FAVORITE_GOAL_REQUEST',
    NOTE_APPLY_FAVORITE_GOAL_SUCCESS: 'NOTE_APPLY_FAVORITE_GOAL_SUCCESS',
    NOTE_APPLY_FAVORITE_GOAL_FAILURE: 'NOTE_APPLY_FAVORITE_GOAL_FAILURE',
    NOTE_CLEAR_GOALS_REQUEST: 'NOTE_CLEAR_GOALS_REQUEST',
    NOTE_CLEAR_GOALS_SUCCESS: 'NOTE_CLEAR_GOALS_SUCCESS',
    NOTE_CLEAR_GOALS_FAILURE: 'NOTE_CLEAR_GOALS_FAILURE',
    NOTE_ADD_ASSESSMENT_FLAG_REQUEST: 'NOTE_ADD_ASSESSMENT_FLAG_REQUEST',
    NOTE_ADD_ASSESSMENT_FLAG_SUCCESS: 'NOTE_ADD_ASSESSMENT_FLAG_SUCCESS',
    NOTE_ADD_ASSESSMENT_FLAG_FAILURE: 'NOTE_ADD_ASSESSMENT_FLAG_FAILURE',
    NOTE_ADD_PLAN_SUB_CAT_REQUEST: 'NOTE_ADD_PLAN_SUB_CAT_REQUEST',
    NOTE_ADD_PLAN_SUB_CAT_SUCCESS: 'NOTE_ADD_PLAN_SUB_CAT_SUCCESS',
    NOTE_ADD_PLAN_SUB_CAT_FAILURE: 'NOTE_ADD_PLAN_SUB_CAT_FAILURE',
    NOTE_UPDATE_ALL_ASSESSMENT_FLAGS_REQUEST: 'NOTE_UPDATE_ALL_ASSESSMENT_FLAGS_REQUEST',
    NOTE_UPDATE_ALL_ASSESSMENT_FLAGS_SUCCESS: 'NOTE_UPDATE_ALL_ASSESSMENT_FLAGS_SUCCESS',
    NOTE_UPDATE_ALL_ASSESSMENT_FLAGS_FAILURE: 'NOTE_UPDATE_ALL_ASSESSMENT_FLAGS_FAILURE',
    NOTE_UPDATE_ALL_GOAL_FLAGS_REQUEST: 'NOTE_UPDATE_ALL_GOAL_FLAGS_REQUEST',
    NOTE_UPDATE_ALL_GOAL_FLAGS_SUCCESS: 'NOTE_UPDATE_ALL_GOAL_FLAGS_SUCCESS',
    NOTE_UPDATE_ALL_GOAL_FLAGS_FAILURE: 'NOTE_UPDATE_ALL_GOAL_FLAGS_FAILURE',
    NOTE_UPDATE_ALL_SHORT_GOAL_FLAGS_REQUEST: 'NOTE_UPDATE_ALL_SHORT_GOAL_FLAGS_REQUEST',
    NOTE_UPDATE_ALL_SHORT_GOAL_FLAGS_SUCCESS: 'NOTE_UPDATE_ALL_SHORT_GOAL_FLAGS_SUCCESS',
    NOTE_UPDATE_ALL_SHORT_GOAL_FLAGS_FAILURE: 'NOTE_UPDATE_ALL_SHORT_GOAL_FLAGS_FAILURE',
    NOTE_TOGGLE_VALIDATION_VISIBILITY: 'NOTE_TOGGLE_VALIDATION_VISIBILITY',
    NOTE_CLEAR_AL_GROUP_REQUEST: 'NOTE_CLEAR_AL_GROUP_REQUEST',
    NOTE_CLEAR_AL_GROUP_SUCCESS: 'NOTE_CLEAR_AL_GROUP_SUCCESS',
    NOTE_CLEAR_AL_GROUP_FAILURE: 'NOTE_CLEAR_AL_GROUP_FAILURE',
    NOTE_COMPUTE_CHARGES_REQUEST: 'NOTE_COMPUTE_CHARGES_REQUEST',
    NOTE_COMPUTE_CHARGES_SUCCESS: 'NOTE_COMPUTE_CHARGES_SUCCESS',
    NOTE_COMPUTE_CHARGES_FAILURE: 'NOTE_COMPUTE_CHARGES_FAILURE',
    SEND_ERROR_REPORT_REQUEST: 'SEND_ERROR_REPORT_REQUEST',
    SEND_ERROR_REPORT_SUCCESS: 'SEND_ERROR_REPORT_SUCCESS',
    SEND_ERROR_REPORT_FAILURE: 'SEND_ERROR_REPORT_FAILURE',
    HIDE_COMPUTED_CHARGES: 'HIDE_COMPUTED_CHARGES',
    NOTE_SAVE_FINAL_REQUEST: 'NOTE_SAVE_FINAL_REQUEST',
    NOTE_SAVE_FINAL_SUCCESS: 'NOTE_SAVE_FINAL_SUCCESS',
    NOTE_SAVE_FINAL_FAILURE: 'NOTE_SAVE_FINAL_FAILURE',
    NOTE_CONVERT_REQUEST: 'NOTE_CONVERT_REQUEST',
    NOTE_CONVERT_SUCCESS: 'NOTE_CONVERT_SUCCESS',
    NOTE_CONVERT_FAILURE: 'NOTE_CONVERT_FAILURE',
    NOTE_SAVE_OBJECTIVE_TEMPLATE_REQUEST: 'NOTE_SAVE_OBJECTIVE_TEMPLATE_REQUEST',
    NOTE_SAVE_OBJECTIVE_TEMPLATE_SUCCESS: 'NOTE_SAVE_OBJECTIVE_TEMPLATE_SUCCESS',
    NOTE_SAVE_OBJECTIVE_TEMPLATE_FAILURE: 'NOTE_SAVE_OBJECTIVE_TEMPLATE_FAILURE',
    DASHBOARD_LOAD_SCHEDULE_REQUEST: 'DASHBOARD_LOAD_SCHEDULE_REQUEST',
    DASHBOARD_LOAD_SCHEDULE_SUCCESS: 'DASHBOARD_LOAD_SCHEDULE_SUCCESS',
    DASHBOARD_LOAD_SCHEDULE_FAILURE: 'DASHBOARD_LOAD_SCHEDULE_FAILURE',
    FLIP_SHOW_CX_NS: 'FLIP_SHOW_CX_NS',
    FLIP_SHOW_UNAVAILABLE: 'FLIP_SHOW_UNAVAILABLE',
    DASHBOARD_LOAD_TODAYS_SCHEDULE_REQUEST: 'DASHBOARD_LOAD_TODAYS_SCHEDULE_REQUEST',
    DASHBOARD_LOAD_TODAYS_SCHEDULE_SUCCESS: 'DASHBOARD_LOAD_TODAYS_SCHEDULE_SUCCESS',
    DASHBOARD_LOAD_TODAYS_SCHEDULE_FAILURE: 'DASHBOARD_LOAD_TODAYS_SCHEDULE_FAILURE',
    DASHBOARD_LOAD_OUTSTANDING_NOTES_REQUEST: 'DASHBOARD_LOAD_OUTSTANDING_NOTES_REQUEST',
    DASHBOARD_LOAD_OUTSTANDING_NOTES_SUCCESS: 'DASHBOARD_LOAD_OUTSTANDING_NOTES_SUCCESS',
    DASHBOARD_LOAD_OUTSTANDING_NOTES_FAILURE: 'DASHBOARD_LOAD_OUTSTANDING_NOTES_FAILURE',
    HELP_CENTER_CATEGORY_CHANGE: 'HELP_CENTER_CATEGORY_CHANGE',

    REQUEST_HELP_REQUEST: 'REQUEST_HELP_REQUEST',
    REQUEST_HELP_SUCCESS: 'REQUEST_HELP_SUCCESS',
    REQUEST_HELP_FAILURE: 'REQUEST_HELP_FAILURE',

    LOCATION_REQUEST: 'LOCATION_REQUEST',
    LOCATION_SUCCESS: 'LOCATION_SUCCESS',
    LOCATION_FAILURE: 'LOCATION_FAILURE',

    WARN_APT_DATE: 'WARN_APT_DATE',
    CLEAR_APT_DATE: 'CLEAR_APT_DATE',

    IS_CHARGE_EXIST: 'IS_CHARGE_EXIST',

    USER_PREFERENCES_REQUEST: 'USER_PREFERENCES_REQUEST',
    USER_PREFERENCES_SUCCESS: 'USER_PREFERENCES_SUCCESS',
    USER_PREFERENCES_FAILURE: 'USER_PREFERENCES_FAILURE',

    SAVE_USER_PREFERENCES_REQUEST: 'SAVE_USER_PREFERENCES_REQUEST',
    SAVE_USER_PREFERENCES_SUCCESS: 'SAVE_USER_PREFERENCES_SUCCESS',
    SAVE_USER_PREFERENCES_FAILURE: 'SAVE_USER_PREFERENCES_FAILURE',

    LOAD_SUPERVISOR_REQUEST: 'LOAD_SUPERVISOR_REQUEST',
    LOAD_SUPERVISOR_SUCCESS: 'LOAD_SUPERVISOR_SUCCESS',
    LOAD_SUPERVISOR_FAILURE: 'LOAD_SUPERVISOR_FAILURE',

    UPDATE_SUPERVISOR_REQUEST: 'UPDATE_SUPERVISOR_REQUEST',
    UPDATE_SUPERVISOR_SUCCESS: 'UPDATE_SUPERVISOR_SUCCESS',
    UPDATE_SUPERVISOR_FAILURE: 'UPDATE_SUPERVISOR_FAILURE',

    LIMBER_ASSESSMENTS_LOAD_REQUEST: 'LIMBER_ASSESSMENTS_LOAD_REQUEST',
    LIMBER_ASSESSMENTS_LOAD_SUCCESS: 'LIMBER_ASSESSMENTS_LOAD_SUCCESS',
    LIMBER_ASSESSMENTS_LOAD_FAILURE: 'LIMBER_ASSESSMENTS_LOAD_FAILURE',

    LIMBER_ASSESSMENTS_LOADING: 'LIMBER_ASSESSMENTS_LOADING',

    LIMBER_PDF_OPEN_REQUEST: 'LIMBER_PDF_OPEN_REQUEST',
    LIMBER_PDF_OPEN_SUCCESS: 'LIMBER_PDF_OPEN_SUCCESS',
    LIMBER_PDF_OPEN_FAILURE: 'LIMBER_PDF_OPEN_FAILURE',
    LIMBER_PDF_LOAD_REQUEST: 'LIMBER_PDF_LOAD_REQUEST',
    LIMBER_PDF_LOAD_SUCCESS: 'LIMBER_PDF_LOAD_SUCCESS',
    LIMBER_PDF_LOAD_FAILURE: 'LIMBER_PDF_LOAD_FAILURE',

    NOTE_GET_LIMBER_OUTCOMES_REQUEST: 'NOTE_GET_LIMBER_OUTCOMES_REQUEST',
    NOTE_GET_LIMBER_OUTCOMES_SUCCESS: 'NOTE_GET_LIMBER_OUTCOMES_SUCCESS',
    NOTE_GET_LIMBER_OUTCOMES_FAILURE: 'NOTE_GET_LIMBER_OUTCOMES_FAILURE',
}